import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddProductTypeModal from "../../components/modals/AddProductTypeModal/AddProductTypeModal";
import EditProductTypeModal from "../../components/modals/EditProductTypeModal/EditProductTypeModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import ProductTypesTable from "../../components/Tables/ProductsTypesTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IProductType } from "../../types/productType.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterProductTypes } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const ProductTypesPage: React.FC = () => {
  const [productsType, setProductsType] = useState<IProductType[]>([]);
  const [filteredProductTypes, setFilteredProductTypes] = useState<
    IProductType[]
  >([]);
  const [editSelectedProductTypes, setEditSelectedProductType] =
    useState<IProductType | null>(null);
  const [visibleProductType, setVisibleProductTypes] = useState<IProductType[]>(
    []
  );
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddProductTypeModal, setIsAddProductTypeModal] =
    useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);

  const getProductTypes = async () => {
    try {
      const results = await authApiService.getAllProductTypes();

      return results;
    } catch (err) {
      console.error(err);
    }
  };
  const changeVisibiltyProductTypes = (types: IProductType[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (types) {
      const changedTypes = types.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleProductTypes(changedTypes);
    }
  };

  const getOptionsFilter = () => {
    let filteredProductTypes = [...productsType];
    // setRole(role);

    // if (role.value !== EmployeeType.NONE) {
    //   filteredUsers = filteredUsers.filter((user) => user.role === role.value);
    // }

    return filteredProductTypes;
  };

  const getFiltredProductTypes = (tags: IProductType[]) => {
    const data = getOptionsFilter();
    const filtered = filterProductTypes(data, searchValue);
    setFilteredProductTypes(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getProductTypes();
    if (resp) {
      setProductsType(resp);
      getFiltredProductTypes(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredProductTypes.length / usersPerPage));
  }, [filteredProductTypes]);

  useEffect(() => {
    getFiltredProductTypes(productsType);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, productsType]);

  useEffect(() => {
    (async () => {
      const data = await getProductTypes();
      if (data) {
        setProductsType(data);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyProductTypes(filteredProductTypes);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, productsType, totalPages, filteredProductTypes]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={productsType?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddProductTypeModal(true)}
            addButtonTitle="Додати"
          />
        </div>
      </div>
      <ProductTypesTable
        types={visibleProductType}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedProductType}
      />

      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {isAddProductTypeModal && (
        <AddProductTypeModal
          onClose={() => setIsAddProductTypeModal(false)}
          onApply={onClickApplyModal}
        />
      )}

      {editSelectedProductTypes && (
        <EditProductTypeModal
          type={editSelectedProductTypes}
          onClose={() => setEditSelectedProductType(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
    </main>
  );
};

export default ProductTypesPage;
